import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './infographic-page-noblurb.component.scss';
var InfographicPageNoblurb = /** @class */ (function (_super) {
    tslib_1.__extends(InfographicPageNoblurb, _super);
    function InfographicPageNoblurb(element) {
        return _super.call(this, element) || this;
    }
    InfographicPageNoblurb.prototype.init = function () {
    };
    InfographicPageNoblurb.prototype.bindEvents = function () {
    };
    return InfographicPageNoblurb;
}(Base));
export { InfographicPageNoblurb };



//////////////////
// WEBPACK FOOTER
// ./components/infographic-page-noblurb/infographic-page-noblurb.component.ts
// module id = 390
// module chunks = 0